/**
 * Keyboard for a WAI-ARIA tablist with automatic activation: ←/→ move to the previous/next tab
 * (wrapping), Home/End to the first/last; the new tab is selected and focused. Only the selected
 * tab sits in the Tab order (`tabindex` 0, the rest -1), so Tab leaves the strip.
 */
export function tabKeyTarget(key: string, index: number, count: number): number | undefined {
  switch (key) {
    case 'ArrowRight':
      return (index + 1) % count
    case 'ArrowLeft':
      return (index - 1 + count) % count
    case 'Home':
      return 0
    case 'End':
      return count - 1
  }
}

export function onTabKeydown(event: KeyboardEvent, index: number, select: (index: number) => void) {
  // Alt+← is the browser's Back; leave modified keys alone.
  if (event.altKey || event.ctrlKey || event.metaKey) return
  const tabs = (event.currentTarget as HTMLElement)
    .closest('[role="tablist"]')
    ?.querySelectorAll<HTMLElement>('[role="tab"]')
  if (!tabs) return
  const target = tabKeyTarget(event.key, index, tabs.length)
  if (target === undefined) return
  event.preventDefault()
  select(target)
  // The component scrolls its own strip (smoothly); a focus scroll would jump it mid-way.
  tabs[target]?.focus({ preventScroll: true })
}
